module.exports = __webpack_public_path__ + "img/history.98e6d91c.png";